import React, { useState, useEffect } from "react";
import retired from '../img/Retired.jpeg';
import Accountants from '../img/account.jpeg';
import Women from '../img/Women.jpeg';
import Students from '../img/student.jpeg';
import Paramilitary from '../img/army.jpeg';
import housewife from '../img/Housewife.jpeg';




const CompanyThree = () => {
    const [activeSlide, setActiveSlide] = useState(0);

    // Slides data for the carousel with imported images
    const slides = [
        {
            title: "Retired Officers & Bankers",
            description: "Your trusted network and decades of experience give you an unbeatable advantage in insurance advisory.",
            image: retired,
            profiles: ["Ex-Bank Managers", "Defense Personnel", "PSU Officers", "Govt Retirees"]
        },
        {
            title: "Accountants & CA Professionals",
            description: "Leverage your financial expertise to provide valuable insurance solutions and build a rewarding practice.",
            image: Accountants,
            profiles: ["Chartered Accountants", "Tax Consultants", "Auditors", "Finance Graduates"]
        },
        {
            title: "Women Professionals & Homemakers",
            description: "Achieve financial independence with flexible hours, work from home, and a supportive women network.",
            image: Women,
            profiles: ["Homemakers", "Working Women", "Career Breakers", "Mothers"]
        },
        {
            title: "Students & Young Graduates",
            description: "Kickstart your career with zero investment, earn while you learn, and grow with the booming insurance sector.",
            image: Students,
            profiles: ["Final Year Students", "MBA Aspirants", "B.Com Graduates", "Interns"]
        },
        {
            title: "Ex-Army & Paramilitary Veterans",
            description: "Discipline, leadership, and trust - transform your military values into a successful second career.",
            image: Paramilitary,
            profiles: ["Army Veterans", "Air Force", "Navy", "CISF/CRPF/BSF"]
        },
        {
            title: "Housewife & Homemakers",
            description: "Turn your caregiving skills and daily connections into a flexible, rewarding profession from home.",
            image: housewife,
            profiles: ["Homemakers", "Mothers", "Empty Nesters", "Retired Women"]
        }
    ];

    // Auto-slide functionality
    useEffect(() => {
        const interval = setInterval(() => {
            setActiveSlide((prev) => (prev + 1) % slides.length);
        }, 3000);

        return () => clearInterval(interval);
    }, [slides.length]);

    const nextSlide = () => {
        setActiveSlide((prev) => (prev + 1) % slides.length);
    };

    const prevSlide = () => {
        setActiveSlide((prev) => (prev - 1 + slides.length) % slides.length);
    };

    const goToSlide = (index) => {
        setActiveSlide(index);
    };

    return (
        <section className="py-5 bg-gradient-light position-relative overflow-hidden">
            <div className="position-absolute top-0 end-0 w-50 h-100 opacity-10" style={{ background: "radial-gradient(circle, #3b82f6 0%, transparent 70%)" }}></div>
            <div className="position-absolute bottom-0 start-0 w-50 h-100 opacity-5" style={{ background: "radial-gradient(circle, #f59e0b 0%, transparent 70%)" }}></div>

            <div className="container position-relative">
                {/* <div className="text-center mb-5" data-aos="fade-up">
                    <span className="badge bg-gradient-warning text-dark px-5 py-2.5 rounded-pill mb-3 fw-bold fs-6 shadow-sm">
                        🌟 WHO CAN JOIN US
                    </span>
                </div> */}

                {/* SLIDER SECTION - CRYSTAL CLEAR IMAGES */}
                <div className="row mb-5" data-aos="fade-up">
                    <div className="col-12">
                        <div className="card border-0 shadow-lg overflow-hidden">
                            <div className="row g-0 align-items-center">
                                {/* Image Side - Crystal clear display */}
                                <div className="col-md-5 p-0">
                                    <div 
                                        className="image-container" 
                                        style={{ 
                                            width: "100%",
                                            height: "320px",
                                            overflow: "hidden",
                                            backgroundColor: "#f8f9fa",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        }}
                                    >
                                        <img 
                                            src={slides[activeSlide].image} 
                                            alt={slides[activeSlide].title}
                                            className="animated-image"
                                            style={{ 
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "contain",
                                                objectPosition: "center",
                                                animation: "imageZoom 0.5s ease-out",
                                                imageRendering: "high-quality",
                                                display: "block"
                                            }}
                                            loading="eager"
                                        />
                                    </div>
                                </div>

                                {/* Content Side */}
                                <div className="col-md-7">
                                    <div className="p-4 p-lg-5 bg-white">
                                        <div>
                                            <h3 className="fw-bold mb-3 text-dark slide-title" style={{ animation: "slideInRight 0.5s ease-out" }}>
                                                {slides[activeSlide].title}
                                            </h3>
                                            <p className="text-muted mb-4 slide-description" style={{ animation: "fadeInUp 0.5s ease-out 0.1s both" }}>
                                                {slides[activeSlide].description}
                                            </p>

                                            {/* Profile tags */}
                                            <div className="d-flex flex-wrap gap-2 mb-4 slide-tags" style={{ animation: "fadeInUp 0.5s ease-out 0.2s both" }}>
                                                {slides[activeSlide].profiles.map((profile, idx) => (
                                                    <span key={idx} className="badge bg-light text-dark border px-3 py-2 rounded-pill fw-medium">
                                                        {profile}
                                                    </span>
                                                ))}
                                            </div>
                                        </div>

                                        {/* Navigation Buttons */}
                                        <div className="d-flex gap-2 justify-content-end">
                                            <button 
                                                onClick={prevSlide}
                                                className="btn btn-outline-primary rounded-circle d-flex align-items-center justify-content-center"
                                                style={{ width: "40px", height: "40px" }}
                                            >
                                                <i className="bi bi-chevron-left"></i>
                                            </button>
                                            <button 
                                                onClick={nextSlide}
                                                className="btn btn-primary rounded-circle d-flex align-items-center justify-content-center"
                                                style={{ width: "40px", height: "40px" }}
                                            >
                                                <i className="bi bi-chevron-right"></i>
                                            </button>
                                        </div>

                                        {/* Slide Indicators */}
                                        <div className="mt-3 d-flex gap-1 justify-content-end">
                                            {slides.map((_, idx) => (
                                                <button
                                                    key={idx}
                                                    onClick={() => goToSlide(idx)}
                                                    className={`rounded-pill border-0 ${activeSlide === idx ? 'bg-primary' : 'bg-secondary bg-opacity-25'}`}
                                                    style={{ 
                                                        width: activeSlide === idx ? "24px" : "8px", 
                                                        height: "8px", 
                                                        padding: 0,
                                                        transition: "all 0.3s ease"
                                                    }}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* INDIA OPPORTUNITY STATISTICS */}
                <div className="row justify-content-center mb-5" data-aos="fade-up">
                    <div className="col-md-10">
                        <div className="bg-white rounded-4 shadow-lg p-4">
                            <div className="row text-center">
                                <div className="col-md-3 border-end">
                                    <div className="display-5 fw-bold text-primary">150Cr+</div>
                                    <p className="text-muted mb-0">India's Population</p>
                                </div>
                                <div className="col-md-3 border-end">
                                    <div className="display-5 fw-bold text-warning">4.9 Mil.</div>
                                    <p className="text-muted mb-0">Insurance Agents Only</p>
                                </div>
                                <div className="col-md-3 border-end">
                                    <div className="display-5 fw-bold text-success">90%</div>
                                    <p className="text-muted mb-0">Untapped Market</p>
                                </div>
                                <div className="col-md-3">
                                    <div className="display-5 fw-bold text-info">Unlimited</div>
                                    <p className="text-muted mb-0">Growth Potential</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ORIGINAL CARDS SECTION - KEPT COMPLETELY INTACT */}
               

               
            </div>

            {/* Animation Styles */}
            <style>{`
                @keyframes imageZoom {
                    0% {
                        transform: scale(1.05);
                        opacity: 0;
                    }
                    100% {
                        transform: scale(1);
                        opacity: 1;
                    }
                }
                
                @keyframes slideInRight {
                    0% {
                        transform: translateX(30px);
                        opacity: 0;
                    }
                    100% {
                        transform: translateX(0);
                        opacity: 1;
                    }
                }
                
                @keyframes fadeInUp {
                    0% {
                        transform: translateY(20px);
                        opacity: 0;
                    }
                    100% {
                        transform: translateY(0);
                        opacity: 1;
                    }
                }
                
                .animated-image {
                    animation: imageZoom 0.5s ease-out;
                }
                
                .slide-title {
                    animation: slideInRight 0.5s ease-out;
                }
                
                .slide-description {
                    animation: fadeInUp 0.5s ease-out 0.1s both;
                }
                
                .slide-tags {
                    animation: fadeInUp 0.5s ease-out 0.2s both;
                }
            `}</style>
        </section>
    );
};

export default CompanyThree;


